import { IconLoading } from '@/assets/icons/icon-loading'
import { Button } from '@/components/ui/button.tsx'
import { Dialog } from '@/components/ui/dialog.tsx'
import { Progress } from '@/components/ui/progress.tsx'

import { useWithdrawMassMessage } from '../../modules/online-mass-messages/hooks/use-withdraw-mass-message'
import { DialogProps } from '../types'

interface WithDrawDialogProps extends DialogProps {
  messageId: number
}

export const WithdrawOmmDialog = ({
  isOpen,
  onClose,
  messageId,
}: WithDrawDialogProps) => {
  const { status, progress, totalMessages, withdrawnMessages } =
    useWithdrawMassMessage(messageId)

  return (
    <Dialog
      show={isOpen}
      onClose={onClose}
    >
      <Dialog.Header>
        <Dialog.Title className="text-center">
          Withdraw Online Mass Message
        </Dialog.Title>
      </Dialog.Header>

      <Dialog.Description>
        {!status && <IconLoading className="mx-auto mt-4 mb-2 animate-spin" />}
        {status === 'FINISHED_WITHDRAWING' && (
          <h3 className="text-center text-title mt-3">
            {totalMessages === 0
              ? 'There are no messages to withdraw. Please note that only messages sent within the last 24 hours can be withdrawn.'
              : `You have successfully withdrawn ${totalMessages} messages!`}
          </h3>
        )}
        {status === 'WAITING_FOR_BROWSER' && (
          <h3 className="text-center text-title mt-3">
            Waiting for a browser to withdraw the messages.. <br />
            <span className="text-warning-default">
              Please make sure there is someone logged into the OnlyFans account
              running CreatorHero right now.
            </span>
            <br />
            <br />
            If this text does not disappear within 60 seconds, there is no-one
            logged in.
          </h3>
        )}
        {status === 'WITHDRAWING' && (
          <>
            <div className="flex justify-between text-sm mb-4 mt-6 text-center text-title">
              <span>{progress ? Math.trunc(progress) : 0}%</span>
              <span>
                {withdrawnMessages || 0} / {totalMessages || 0}
              </span>
            </div>

            <Progress value={progress} />
          </>
        )}
      </Dialog.Description>
      <Dialog.Footer>
        <Button
          variant="outline"
          className="w-full"
          onClick={onClose}
        >
          {status === 'WITHDRAWING' ? 'Run in background' : 'Close'}
        </Button>
      </Dialog.Footer>
    </Dialog>
  )
}
